import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter } from 'react-router-dom';
import ErrorBoundry from './ErrorBoundry'
import App from './App'

ReactDOM.render(
<BrowserRouter>
<ErrorBoundry>
    <App/>
</ErrorBoundry>
</BrowserRouter>, document.getElementById('root'))


// WEBPACK FOOTER //
// ./src/index.js